import Icon, { IconName } from './Icon';

export { IconName };
export default Icon;
